export const transform = data => {
  if (!data) {
    return undefined;
  }

  return data.map(store => ({
    number: store.id,
    name: store.displayNameAlternate
  }));
};
